
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.414.487C4.414.217 4.63 0 4.9 0h6.4c.27 0 .487.218.487.487v2.948h3.827a.487.487 0 110 .973h-1.322v11.105a.487.487 0 01-.487.487H2.535a.487.487 0 01-.487-.487V4.408H.587a.487.487 0 110-.973h3.827V.487zm.973 2.948h5.427V.973H5.387v2.462zm-2.365.973v10.619h10.296V4.408H3.022zm2.785 2.891a.487.487 0 01.688-.002L8.1 8.889l1.606-1.592a.487.487 0 01.685.69l-1.6 1.587 1.6 1.587a.487.487 0 11-.685.69L8.1 10.26l-1.605 1.592a.487.487 0 01-.685-.691l1.6-1.587-1.6-1.586a.487.487 0 01-.003-.689z","fill":"currentColor"}})])
          )
        }
      }
    